import React, { Fragment, PureComponent } from 'react';
import { Input } from 'semantic-ui-react';

import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';

import { GridInputCell } from './GridInputCell';

class OfferedSectionRow extends PureComponent {
  render() {
    const {
      onInputChange,
      [ProdRecordDetailFields.ArrayIndex]: index,
      collapsed,
      ...detailProps
    } = this.props;

    const isIngredient = ProdRecordHelpers.isDetailIngredient(detailProps);    

    return (
      <Fragment>
        <GridInputCell
          {...detailProps}
          inputProps={{
            name: ProdRecordDetailFields.Offered,
            onChange: onInputChange,
            value: detailProps[ProdRecordDetailFields.Offered],
            'data-index': index,
          }}
          mode={InputMode.Integer}
        />
        {!collapsed && (
          <Fragment>
            <GridInputCell
              {...detailProps}
              inputProps={{
                onChange: onInputChange,
                name: ProdRecordDetailFields.OfferedPreK,
                value: detailProps[ProdRecordDetailFields.OfferedPreK],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                onChange: onInputChange,
                name: ProdRecordDetailFields.OfferedAlacarte,
                value: detailProps[ProdRecordDetailFields.OfferedAlacarte],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.OfferedAdult,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.OfferedAdult],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            {isIngredient ? (
              <Input className="menu-input" disabled value="" />
            ) : (
              <Input
                className="menu-input"
                value={ProdRecordHelpers.computeOfferedTotal(detailProps)}
                fluid
                disabled
              />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export { OfferedSectionRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/OfferedSectionRow.js